export default {
    buttons: {
        save: 'Сохранить',
    },
    fields: {
        email: {
            label: 'Электронная почта',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        password: {
            label: 'Пароль',
            placeholder: 'Минимум 6 символов',
        },
        password_repeat: {
            label: 'Повторите пароль',
            placeholder: 'Введите пароль ещё раз',
        },
    },
    passwords_not_match: 'Пароли не совпадают',
}
